import loadData from './load-data';
import core_viz from './core-viz';
import lang from './lang';
import util from './_utils';
import filters from './filters';

const container = d3.select('.graphic__chart'),
	rightPanel = d3.select('.graphic__right'),
	header = d3.select('.viz-header'),
	svg = container.select('.svg__community'),
	g = svg.select('.community'),
	g_axes = g.select('.comm-axes'),
	g_bubbles = g.select('.comm-bubbles'),
	g_text = g.select('.comm-text');

let margin, x, y, r, w, h;

let baseData, data, vizParameters, isMobile, isTablet, drawn = false;

let bubbles, bubbleGs, axes, track, starts, y_labels, x_labels;

let domainX, domainY;

const indexes = {
	'Group of Friends': 0,
	'Run Club/Group': 1,
	'Work colleagues': 2,
	'Sports Team': 3,
	'Fitness Class': 4,
	"I don't run with other people": 5
}

const chapter = 'community',
	yAccessor = 'Group',
	xAccessor = 'Age';

let startW = 18;

const selectors = {
		age: 'Total',
		sex: 'Total',
		nationality: 'Total'
	},
	duration = {
		fast: 250,
		medium: 500,
		slow: 1000,
		reallySlow: 5000
	};

let step = 0;

function next(index) {
	step = index + 1;

	if (!drawn) {
		draw();
	} else {
		if (step == 0) {
			selectors.age = 'Total';
			selectors.sex = 'Total';
			selectors.nationality = 'Total';
			filters.set(null, null, null);
			update();
		} else if (step == 1) {
			selectors.age = 'Total';
			selectors.sex = 'Total';
			selectors.nationality = 'Total';
			filters.set(null, null, null);
			update();
		} else if (step == 2) {
			selectors.age = 'Total';
			selectors.sex = 'F';
			selectors.nationality = 'Total';
			filters.set('F', null, null);
			update();
		} else if (step == 3) {
			selectors.age = 'Total';
			selectors.sex = 'Total';
			selectors.nationality = 'Japan';
			filters.set(null, 'Japan', null);
			update();
		}
	}
}

function filter(selectedFilters) {
	let ageChange = false;
	if (selectedFilters.age != selectors.age) ageChange = true;
	selectors.age = selectedFilters.age;
	selectors.sex = selectedFilters.sex;
	selectors.nationality = selectedFilters.nationality;
	updateFilter(ageChange);
}

function init() {
	step = 0;

	return new Promise((resolve, reject) => {
		Promise.all([
			loadData(['community.csv']),
		]).then(function(result) {
			baseData = util.parseData(result[0][0]).filter(d => d.Age != 'Exclude');

			baseData.forEach(d => {
				d.Group = d.Group == `I don't run with other people` ? 'Alone' : d.Group;
			});

			setup();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function setup(resize = false) {
	isMobile = util.isMobile();
	isTablet = util.isTablet();
	vizParameters = getVizParameters();

	data = getData(baseData);

	domainX = d3.map(baseData, d => d.Age).keys();
	domainY = d3.map(baseData, d => d.Group).keys();

	domainY = ['Group of friends', 'Run club/group', 'Work colleagues', 'Sports team', 'Fitness class', 'Alone'];

	margin = {
		top: vizParameters.headerH + (isMobile ? 40 : 50),
		right: isMobile ? 0 : 0,
		// bottom: isMobile ? 25 : 100,
		bottom: getBottomMargin(),
		left: getLeftMargin() + (isMobile ? 20 : 70),
	}

	w = vizParameters.outerW - margin.right - margin.left;
	h = vizParameters.outerH - margin.top - margin.bottom;

	let rMax = isMobile ? h * .1 : h * .1;

	x = d3.scaleBand().domain(domainX).range([0, w]).padding(0.05);
	y = d3.scaleBand().domain(domainY).range([0, h]).padding(0.05);
	r = d3.scaleSqrt().domain([0, d3.max(baseData, d => d.Percent)]).range([0, rMax]);

	g.attr('transform', `translate(${margin.left}, ${margin.top})`);
}

function draw() {
	drawn = true;
	// core_viz.stopSimulation();

	/*
	d3.select('.svg__love-hate').selectAll('.bubble')
		.transition().delay((d, i) => i * .2).duration(1000)
		.attr('cx', d => d.x > vizParameters.outerW / 2 ? vizParameters.outerW + 200 + (Math.random() * 100) : -200 - (Math.random() * 100))
		.style('opacity', 0)
		.transition().duration(0)
		.style('visibility', 'hidden');
	*/

	const startParameters = getBubbleParameters();

	starts = g_axes.selectAll('.track-start-line').data(data);
	track = g_axes.selectAll('.track-line').data(data);
	y_labels = g_text.selectAll('.axis__label--y').data(data);
	x_labels = g_text.selectAll('.axis__label--x').data(domainX);
	bubbleGs = g_bubbles.selectAll('.comm_bubbles__g').data(data);

	starts.enter()
		.append('line').attr('class', 'track-start-line')
		.attr('x1', x(0)).attr('x2', x(0))
		.attr('y1', d => y(d.key) + y.bandwidth() / 2 - startW / 2).attr('y2', d => y(d.key) + y.bandwidth() / 2 - startW / 2)
		.transition().duration(duration.slow)
		.delay((d, i) => i * 75)
		.attr('y2', d => y(d.key) + y.bandwidth() / 2 + startW / 2);

	track.enter()
		.append('line').attr('class', 'track-line')
		.attr('x1', x(0)).attr('x2', x(0))
		.attr('y1', d => y(d.key) + y.bandwidth() / 2).attr('y2', d => y(d.key) + y.bandwidth() / 2)
		.transition().duration(duration.slow).delay((d, i) => duration.medium + i * 100)
		.attr('x2', w);

	y_labels.enter()
		.append('text').attr('class', 'axis__label axis__label--y')
		.attr('x', x(0)).attr('y', d => y(d.key) + y.bandwidth() / 2)
		.attr('dx', 10).attr('dy', 6)
		.text(d => lang.translateViz(chapter, `${yAccessor}--${d.key}`))
		.call(wrapYAxisText, margin.left - 40)
		.style('opacity', 0)
		.transition().duration(duration.medium).delay((d, i) => duration.medium + i * 50)
		.style('opacity', 1)
		.attr('dx', -10)

	x_labels.enter()
		.append('text').attr('class', 'axis__label axis__label--x')
		.attr('x', d => x(d) + x.bandwidth() / 2).attr('y', h)
		.attr('dx', 10)
		// .attr('dy', 14)
		.text(d => lang.translateViz(chapter, `${xAccessor}--${d}`))
		.call(wrap, w / 5 - 40)
		.style('opacity', 0)
		.transition().duration(duration.medium).delay((d, i) => duration.slow + i * 50)
		.attr('dx', 0)
		.style('opacity', 1);

	bubbleGs.enter()
		.append('g').attr('class', 'comm_bubbles__g');

	bubbles = g_bubbles.selectAll('.comm_bubbles__g').selectAll('.comm_bubbles__bubble').data(d => d.values);

	bubbles.enter()
		.append('circle').attr('class', 'comm_bubbles__bubble')
		.attr('cx', d => startParameters.x[indexes[d.Group]])
		.attr('cy', d => startParameters.y[indexes[d.Group]])
		.attr('r', d => startParameters.r[indexes[d.Group]])
		.transition().duration(duration.medium)
		.attr('cx', x('Total')).attr('cy', d => y(d.Group) + y.bandwidth() / 2)
		.transition().duration(duration.medium)
		.attr('cx', d => x(d.Age) + x.bandwidth() / 2)
		.attr('r', d => r(d.Percent));
}

function updateFilter(ageChange) {
	data = getData(baseData)

	bubbleGs = g_bubbles.selectAll('.comm_bubbles__g').data(data);
	bubbles = g_bubbles.selectAll('.comm_bubbles__g').selectAll('.comm_bubbles__bubble').data(d => d.values, d => d.Age);
	x_labels = g_text.selectAll('.axis__label--x');

	bubbleGs.merge(bubbleGs);

	bubbles.merge(bubbles)
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('r', d => r(d.Percent))
		.style('fill', function(d) {
			return ageChange ? (d.Age == selectors.age ? '#1F63F3' : '#d1d1d1') : d3.select(this).style('fill');
		})
		.style('fill-opacity', function(d) {
			return d.Age == selectors.age ? .9 : .5;
		});

	x_labels.transition().duration(duration.medium)
		.style('fill', function(d) {
			return ageChange ? (d == selectors.age ? '#1F63F3' : '#d1d1d1') : d3.select(this).style('fill');
		})
}

function update() {
	data = getData(baseData);

	bubbleGs = g_bubbles.selectAll('.comm_bubbles__g').data(data);
	bubbles = g_bubbles.selectAll('.comm_bubbles__g').selectAll('.comm_bubbles__bubble').data(d => d.values, d => d.Age);
	x_labels = g_text.selectAll('.axis__label--x');

	bubbleGs.merge(bubbleGs);

	bubbles.merge(bubbles)
		.transition().duration(duration.medium).delay((d, i) => i * 50)
		.attr('r', d => r(d.Percent))
		.style('fill', d => {
			if (step == 0) return '#d1d1d1';
			if (step == 1) return (d.Age == 'Under 35' && d.Group == 'Work colleagues') || (d.Age == '55+' && d.Group == 'Alone') ? '#1F63F3' : '#d1d1d1';
			if (step == 2) return d.Group == 'Run club/group' ? '#1F63F3' : '#d1d1d1';
			if (step == 3) return d.Group == 'Alone' ? '#1F63F3' : '#d1d1d1';
		})
		.style('fill-opacity', d => {
			if (step == 0) return '.5';
			if (step == 1) return (d.Age == 'Under 35' && d.Group == 'Work colleagues') || (d.Age == '55+' && d.Group == 'Alone') ? '.9' : '.5';
			if (step == 2) return d.Group == 'Run club/group' ? '.9' : '.5';
			if (step == 3) return d.Group == 'Alone' ? '.9' : '.5';
		});

	x_labels.transition().duration(duration.medium)
		.style('fill', d => {
			if (step == 1) return d == 'Under 35' || d == '55+' ? '#1F63F3' : '#d1d1d1';
			return '#d1d1d1';
		})

	if (step == 1) {
		setTimeout(() => {
			setupMouseoverText();
		}, 1000)
	}
}

function setupMouseoverText() {
	d3.selectAll('.comm-mouseover-classmates').on('mouseover', () => {
		bubbles.transition().style('opacity', d => d.Age == 'Under 35' && d.Group == 'Work colleagues' ? 1 : .25);
	}).on('mouseout', () => {
		bubbles.transition().style('opacity', 1);
	})

	d3.selectAll('.comm-mouseover-solo').on('mouseover', () => {
		bubbles.transition().style('opacity', d => d.Age == '55+' && d.Group == 'Alone' ? 1 : .25);
	}).on('mouseout', () => {
		bubbles.transition().style('opacity', 1);
	})
}

function end() {
	if (drawn) {
		starts = g_axes.selectAll('.track-start-line').data([]);
		track = g_axes.selectAll('.track-line').data([]);
		y_labels = g_text.selectAll('.axis__label--y').data([]);
		x_labels = g_text.selectAll('.axis__label--x').data([]);
		bubbleGs = g_bubbles.selectAll('.comm_bubbles__g').data([]);
		bubbles = g_bubbles.selectAll('.comm_bubbles__g').selectAll('.comm_bubbles__bubble').data([]);

		starts.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 25)
			.attr('y2', d => y(d.key) + y.bandwidth() / 2 - startW / 2)
			.remove();

		track.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 25)
			.attr('x2', x(0))
			.remove();

		y_labels.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 25)
			.style('opacity', 0)
			.remove();

		x_labels.exit()
			.transition().duration(duration.fast).delay((d, i) => i * 25)
			.style('opacity', 0)
			.remove();

		bubbles.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 25)
			.attr('r', 0)
			.remove();

		bubbleGs.exit()
			.transition().duration(duration.slow).delay((d, i) => i * 25)
			.remove();

		drawn = false;

	}
}

function resizeComm() {
	if (drawn) {
		starts = g_axes.selectAll('.track-start-line');
		track = g_axes.selectAll('.track-line');
		y_labels = g_text.selectAll('.axis__label--y');
		x_labels = g_text.selectAll('.axis__label--x');
		bubbleGs = g_bubbles.selectAll('.comm_bubbles__g');
		bubbles = g_bubbles.selectAll('.comm_bubbles__g').selectAll('.comm_bubbles__bubble');

		starts.transition().duration(0)
			.attr('x1', x(0)).attr('x2', x(0))
			.attr('y1', d => y(d.key) + y.bandwidth() / 2 - startW / 2).attr('y2', d => y(d.key) + y.bandwidth() / 2 + startW / 2);

		track.transition().duration(0)
			.attr('x1', x(0)).attr('x2', w)
			.attr('y1', d => y(d.key) + y.bandwidth() / 2).attr('y2', d => y(d.key) + y.bandwidth() / 2);

		y_labels.transition().duration(0)
			.attr('x', x(0)).attr('y', d => y(d.key) + y.bandwidth() / 2);

		x_labels.transition().duration(0)
			.attr('x', d => x(d) + x.bandwidth() / 2).attr('y', h);

		bubbles.transition().duration(0)
			.attr('cx', d => x(d.Age) + x.bandwidth() / 2).attr('cy', d => y(d.Group) + y.bandwidth() / 2)
			.attr('r', d => r(d.Percent));
	}
}

function getVizParameters() {
	const rightW = rightPanel.node().offsetWidth,
		rightH = rightPanel.node().offsetHeight,
		headerH = isMobile ? 56 : 75,
		outerW = container.node().offsetWidth - (isMobile ? 0 : rightW),
		// outerH = container.node().offsetHeight - (isMobile ? rightH : 0);
		outerH = container.node().offsetHeight / (isMobile ? 2 : 1);

	const x = outerW / 2,
		y = outerH / 2;

	return {
		rightW: rightW,
		rightH: rightH,
		headerH: headerH,
		outerW: outerW,
		outerH: outerH,
		x: x,
		y: y
	};
}

function getBubbleParameters() {
	let bubbles = d3.select('.svg__love-hate').selectAll('circle')
		.filter(function() {
			return d3.select(this).attr('fill') == '#1F63F3';
		});

	const b1 = bubbles.filter((d, i) => i == 0),
		b2 = bubbles.filter((d, i) => i == 1),
		b3 = bubbles.filter((d, i) => i == 2),
		b4 = bubbles.filter((d, i) => i == 3),
		b5 = bubbles.filter((d, i) => i == 4),
		b6 = bubbles.filter((d, i) => i == 5);

	const x = [+b1.attr('cx'), +b2.attr('cx'), +b3.attr('cx'), +b4.attr('cx'), +b5.attr('cx'), +b6.attr('cx')],
		y = [+b1.attr('cy'), +b2.attr('cy'), +b3.attr('cy'), +b4.attr('cy'), +b5.attr('cy'), +b6.attr('cy')],
		r = [+b1.attr('r'), +b2.attr('r'), +b3.attr('r'), +b4.attr('r'), +b5.attr('r'), +b6.attr('r')]

	return {
		x: x,
		y: y,
		r: r
	}
}

function getLeftMargin(values) {
	const fakeTextWidths = [];

	const fakeTextValues = svg.selectAll('.fake-margin-text')
		.data(domainY)
		.enter()
		.append('text')
		.attr('x', -1000)
		.attr('y', -1000)
		.attr('visibility', 'hidden')
		.text(d => `${lang.translateViz(chapter, `${yAccessor}--${d}`)}`)
		.each(function() {
			fakeTextWidths.push(d3.select(this).node().getComputedTextLength());
		});

	fakeTextValues.remove();

	const max = d3.max(fakeTextWidths);

	if (isMobile && max > vizParameters.outerW / 3) {
		return vizParameters.outerW / 3;
	} else {
		return max;
	}
}

function getBottomMargin(values) {
	const fakeTextHeights = [];

	const fakeTextValues = svg.selectAll('.fake-margin-text-bottom')
		.data(domainX)
		.enter()
		.append('text')
		.attr('x', -1000)
		.attr('y', -1000)
		.attr('visibility', 'hidden')
		.text(d => `${lang.translateViz(chapter, `${xAccessor}--${d}`)}`)
		.each(function() {
			fakeTextHeights.push(d3.select(this).node().getBBox().height);
		});

	fakeTextValues.remove();

	return d3.max(fakeTextHeights) + (isMobile ? 60 : 100);
}

function wrap(text, width) {
	text.each(function() {
		var text = d3.select(this),
			words = text.text().split(/\s+/).reverse(),
			word,
			line = [],
			lineNumber = 0,
			// lineHeight = isMobile ? 9.1 : (isTablet ? 9.1 : 1.5),
			lineHeight = 1.2,
			x = text.attr('x'),
			y = text.attr('y'),
			dy = text.attr('dy') ? text.attr('dy') : .8;

		let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');

		while (word = words.pop()) {
			line.push(word);
			tspan.text(line.join(' '));
			if (tspan.node().getComputedTextLength() > width) {
				if (line.length > 1) {
					line.pop();
					tspan.text(line.join(' '));
					line = [word];
					tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
				}
			}
		}
	});
}

function wrapYAxisText(text, width) {
	text.each(function() {
		var text = d3.select(this),
			words = text.text().split(/\s+/).reverse(),
			word,
			line = [],
			lineNumber = 0,
			// lineHeight = isMobile ? 9.1 : (isTablet ? 9.1 : 1.5),
			lineHeight = 1.6,
			x = text.attr('x'),
			y = text.attr('y'),
			dy = text.attr('dy') ? text.attr('dy') : -15;

		let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y);

		while (word = words.pop()) {
			line.push(word);
			tspan.text(line.join(' '));
			if (tspan.node().getComputedTextLength() > width) {
				if (line.length > 1) {
					line.pop();
					tspan.text(line.join(' '));
					line = [word];
					tspan = text.append('tspan').attr('x', -10).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
				}
			}
		}

		//const textH = text.node().getBBox().height / 2;
		//text.style('vertical-align', 'middle');
	});

}

function filterData(d) {
	d = d.filter(d => {
		return d.Sex == selectors.sex && d.Nationality == selectors.nationality
	});
	return d;
}

function getData(d) {
	d = d3.nest()
		.key(d => d.Group)
		.entries(filterData(d));

	return d;
}

export default {
	init,
	next,
	setup,
	filter,
	resizeComm,
	end
}